module.exports = __webpack_public_path__ + "img/zia-mahmood.145d02fc.jpg";